// Card look shared by the Edit Venue sections (ZONA fee, Floor plan).
export const cardStyles = {
  card: { background: "#0a0a0a", border: "1px solid #1a1a1a", borderRadius: 14, padding: 18, margin: "20px 0" },
  label: {
    fontSize: 11,
    fontWeight: 700,
    color: "rgba(255,255,255,0.4)",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 8,
  },
  help: { fontSize: 13, color: "rgba(255,255,255,0.6)", lineHeight: 1.5, margin: "0 0 14px" },
  row: { display: "flex", gap: 14, flexWrap: "wrap" },
  field: { display: "flex", flexDirection: "column", gap: 6, flex: "1 1 180px" },
  fieldLabel: { fontSize: 13, color: "rgba(255,255,255,0.6)" },
  input: {
    background: "#050505",
    border: "1px solid #1a1a1a",
    borderRadius: 10,
    color: "#fff",
    padding: "12px 14px",
    fontSize: 14,
    outline: "none",
  },
};
